exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".assessment-info .fl-header-survey-assessment{font-weight:700;color:#9dc3cc;letter-spacing:.5px}.assessment-info .fl-header-survey-user-name{color:#1e3c4d;font-style:italic;text-align:right;letter-spacing:.5px}@media(max-width:767px){.assessment-info .fl-header-survey-assessment{line-height:16px;font-size:14px;text-align:right}.assessment-info .fl-header-survey-user-name{font-size:13px;line-height:16px;font-weight:400}}@media(min-width:1200px){.assessment-info .fl-header-survey-assessment{line-height:36px;font-size:30px}.assessment-info .fl-header-survey-user-name{font-size:16px;line-height:19px;font-weight:700}}", ""]);

// exports
